import React, {FC} from 'react';

/** 配送政策俄语正文（与 content/en 结构 1:1）。2026-09-17 AI-перевод, юридические формулировки ожидают проверки бизнесом */
const RuContent: FC = () => {
  return (
    <>
      <p className="v3-doc-meta">Дата вступления в силу: August 28, 2026</p>
      <p className="v3-doc-meta">Дата последнего обновления: August 28, 2026</p>
      <p>Благодарим вас за выбор сервисов Xiangji.</p>
      <p>
        Настоящая Политика доставки сервисов Xiangji (далее — «Политика») описывает, каким образом Xiangji предоставляет
        пользователям услуги класса «программное обеспечение как сервис» (SaaS), обработку визуального контента с
        применением ИИ и иные цифровые услуги, включая способы доставки, сроки доставки, активацию услуг и связанные с
        этим вопросы.
      </p>
      <p>
        <strong>
          Все услуги, предоставляемые Xiangji, являются цифровыми услугами и, как правило, не связаны с производством,
          хранением или логистической доставкой физических товаров.
        </strong>
      </p>
      <section>
        <h2>1. Доставка цифровых услуг</h2>
        <h3>Характер услуг</h3>
        <p>
          Xiangji в основном предоставляет пользователям цифровые продукты и услуги через интернет, включая, помимо
          прочего:
        </p>
        <ul>
          <li>перевод изображений;</li>
          <li>редактирование и ретушь изображений;</li>
          <li>генерацию изображений с помощью ИИ;</li>
          <li>генерацию сценовых изображений товаров;</li>
          <li>генерацию изображений товаров с моделями;</li>
          <li>генерацию главных и дополнительных изображений товаров;</li>
          <li>генерацию комплектов детальных изображений товаров;</li>
          <li>генерацию детальных страниц товаров и контента A+;</li>
          <li>обработку видео и визуального контента;</li>
          <li>обработку файлов и PSD;</li>
          <li>API и иные технические услуги;</li>
          <li>подписочные услуги и соответствующие преимущества членства;</li>
          <li>баллы, Credits и иные преимущества цифровых услуг.</li>
        </ul>
        <p>
          <strong>
            Все перечисленные выше услуги предоставляются через веб-сайт Xiangji, клиентские приложения, браузерные
            расширения, API или иные онлайн-каналы; доставка физических товаров не предусмотрена.
          </strong>
        </p>
      </section>
      <section>
        <h2>2. Способы доставки услуг</h2>
        <h3>Доставка через учётную запись</h3>
        <p>
          Если для услуги требуется регистрация учётной записи, то после завершения вами регистрации или входа в систему
          и успешной активации соответствующей услуги вы можете пользоваться ею через свою учётную запись Xiangji.
        </p>
        <h3>Доставка услуг по подписке</h3>
        <p>
          В случае подписочных услуг после завершения вами оплаты и успешного подтверждения заказа соответствующие
          преимущества подписки, как правило, автоматически привязываются к вашей учётной записи Xiangji.
        </p>
        <p>
          <strong>
            Вам не нужно ожидать физической отгрузки или логистической доставки: услуги по подписке, как правило,
            становятся доступны сразу после завершения заказа.
          </strong>
        </p>
        <p>
          Конкретный срок подписки, объём преимуществ, лимиты использования и срок действия определяются страницей
          покупки и соответствующим соглашением о подписке.
        </p>
        <h3>Доставка баллов и квот</h3>
        <p>
          Баллы, Credits, лимиты использования или иные цифровые преимущества, предоставляемые Xiangji, как правило,
          автоматически зачисляются на вашу учётную запись Xiangji после успешной оплаты и подтверждения заказа.
        </p>
        <p>
          Просмотреть соответствующие преимущества можно в балансе учётной записи, в истории заказов или на
          соответствующих страницах услуг.
        </p>
        <h3>Доставка разовых услуг</h3>
        <p>
          Для услуг, тарифицируемых за каждую задачу или по объёму, — таких как перевод изображений, редактирование
          изображений, генерация изображений с помощью ИИ и генерация комплектов детальных изображений, — после отправки
          вами задачи и завершения соответствующей оплаты Xiangji обрабатывает вашу задачу в соответствии с порядком
          оказания услуги, отображённым на странице продукта.
        </p>
        <p>
          <strong>
            Сгенерированные результаты, обработанные материалы или иные цифровые результаты, как правило,
            предоставляются непосредственно через интерфейс продукта Xiangji; после завершения задачи вы можете
            просмотреть, загрузить или дополнительно отредактировать их.
          </strong>
        </p>
        <h3>API-услуги</h3>
        <p>
          В случае API-услуг после завершения вами регистрации учётной записи, активации API-услуги и выполнения
          необходимой настройки Xiangji предоставляет вам доступ к API в соответствии с применимым соглашением об
          API-услугах или технической документацией.
        </p>
        <p>
          Конкретный способ доставки, лимиты вызовов, квоты, порядок тарификации и технические требования API-услуг
          определяются страницами API-услуг и соответствующими соглашениями.
        </p>
      </section>
      <section>
        <h2>3. Сроки доставки</h2>
        <h3>Автоматическая доставка</h3>
        <p>
          Если на страницах продуктов не указано иное, стандартные цифровые услуги, предоставляемые Xiangji, как
          правило, доставляются в автоматическом режиме.
        </p>
        <p>
          <strong>
            После успешной оплаты, подтверждения заказа и при необходимости прохождения требуемой проверки безопасности
            соответствующие услуги, как правило, активируются немедленно или в разумный срок.
          </strong>
        </p>
        <h3>Услуги ИИ-генерации и обработки</h3>
        <p>
          Генерация изображений с помощью ИИ, перевод изображений, редактирование изображений, обработка видео и другие
          ресурсоёмкие услуги требуют системной обработки.
        </p>
        <p>
          В зависимости от сложности задачи, размера файла, загрузки серверов, скорости обработки моделями ИИ и других
          технических факторов, <strong>фактическое время обработки может различаться.</strong>
        </p>
        <p>
          Ожидаемое время обработки, отображаемое на страницах продуктов, носит справочный характер и не является
          абсолютным обязательством соблюдения конкретного срока завершения.
        </p>
        <h3>Ручные или специальные услуги</h3>
        <p>
          Если услуга требует ручной проверки, ручной обработки, специальной настройки или иных дополнительных действий,
          конкретный срок доставки определяется страницей услуги, страницей заказа или отдельным соглашением между
          сторонами.
        </p>
      </section>
      <section>
        <h2>4. Подтверждение заказа и оплаты</h2>
        <h3>Успешная оплата</h3>
        <p>
          После того как вы завершите оплату заказа, платёжной организации может потребоваться некоторое время для
          подтверждения транзакции.
        </p>
        <p>
          <strong>
            Только после того как система Xiangji подтвердит успешную оплату заказа, соответствующие преимущества
            цифровой услуги будут доставлены в соответствии с настоящей Политикой.
          </strong>
        </p>
        <h3>Сбои при оплате</h3>
        <p>
          Если вы завершили оплату, но в вашей учётной записи Xiangji не отображается успешный заказ, преимущества
          услуги не были зачислены или возникла любая иная нештатная ситуация, незамедлительно обратитесь в службу
          поддержки клиентов Xiangji.
        </p>
        <p>Xiangji рассмотрит вопрос по фактическим обстоятельствам после проверки статуса заказа и оплаты.</p>
        <h3>Платежи через третьи стороны</h3>
        <p>
          Если вы совершаете оплату через стороннюю платёжную организацию, со стороны этой организации возможны проверка
          транзакций, задержки платежа, обработка возвратов или иные технические проблемы.
        </p>
        <p>
          В случае задержек платежа или сбоев, вызванных самой сторонней платёжной организацией, Xiangji окажет вам
          содействие в их урегулировании в разумных пределах.
        </p>
      </section>
      <section>
        <h2>5. Учётная запись и доступ к услугам</h2>
        <h3>Ответственность за учётную запись</h3>
        <p>
          <strong>
            Вы должны следить за тем, чтобы сведения учётной записи Xiangji, используемые при регистрации и покупке,
            были точными и действительными, а также обеспечивать сохранность своей учётной записи и учётных данных для
            входа.
          </strong>
        </p>
        <p>
          Преимущества услуг, как правило, привязываются к учётной записи Xiangji, использованной на момент покупки.
        </p>
        <h3>Ошибочная учётная запись</h3>
        <p>
          Если по зависящим от вас причинам вы приобрели услуги, используя ошибочную учётную запись, в результате чего
          соответствующие преимущества услуг были привязаны к другой учётной записи, вам следует незамедлительно
          обратиться в службу поддержки для проверки.
        </p>
        <p>
          <strong>
            В пределах, допускаемых законом, Xiangji не несёт ответственности за убытки, возникшие вследствие сбоев в
            предоставлении преимуществ услуг, вызванных вашими собственными ошибочными действиями.
          </strong>
        </p>
        <h3>Совместное использование учётной записи</h3>
        <p>
          За исключением корпоративной версии, многопользовательского взаимодействия или иных командных функций, явно
          поддерживаемых Xiangji, вы не вправе предоставлять услуги третьим лицам путём сдачи учётной записи в аренду,
          предоставления во временное пользование, передачи или совместного использования учётных записей.
        </p>
      </section>
      <section>
        <h2>6. Сбои при доставке</h2>
        <p>
          Если вы столкнулись с любой из следующих ситуаций, незамедлительно обратитесь в службу поддержки клиентов
          Xiangji:
        </p>
        <ul>
          <li>оплата прошла успешно, но услуга не была активирована;</li>
          <li>баллы или Credits не были зачислены;</li>
          <li>преимущества подписки не вступили в силу;</li>
          <li>задачи ИИ в течение длительного времени остаются незавершёнными;</li>
          <li>завершённые задачи невозможно надлежащим образом просмотреть или загрузить;</li>
          <li>API-услуги не были активированы надлежащим образом;</li>
          <li>иные сбои, связанные с доставкой услуг.</li>
        </ul>
        <p>
          После проверки заказа, учётной записи и системных записей Xiangji в разумных пределах повторно предоставит
          преимущества, повторно обработает задачи, восстановит услуги или примет иные разумные меры.
        </p>
        <h3>Причины со стороны системы</h3>
        <p>
          <strong>
            Если сбой системы Xiangji привёл к некорректной доставке фактически приобретённых вами преимуществ услуг и
            соответствующие записи о заказе и оплате поддаются достоверной проверке, Xiangji по фактическим
            обстоятельствам повторно предоставит соответствующие преимущества или примет иные разумные меры по
            устранению последствий.
          </strong>
        </p>
        <h3>Причины со стороны пользователя</h3>
        <p>В пределах, допускаемых законом, Xiangji не несёт ответственности за сбои доставки, вызванные следующим:</p>
        <ul>
          <li>пользователь предоставил неверные сведения учётной записи;</li>
          <li>пользователь самостоятельно изменил или удалил соответствующие сведения учётной записи;</li>
          <li>учётная запись пользователя была заблокирована или ограничена;</li>
          <li>устройство, сеть или программная среда пользователя находились в нештатном состоянии;</li>
          <li>пользователь не выполнил требуемую услугой необходимую настройку;</li>
          <li>иные случаи, когда услуга не может использоваться нормально по причинам, зависящим от пользователя.</li>
        </ul>
      </section>
      <section>
        <h2>7. Недоступность услуг и услуги третьих сторон</h2>
        <p>
          Некоторые продукты и функции Xiangji зависят от услуг облачных вычислений, моделей ИИ, движков перевода,
          сетевых провайдеров, платёжных организаций и иных технических услуг третьих сторон.
        </p>
        <p>
          <strong>
            Сбои, техническое обслуживание, обновления, ограничения мощности, изменения интерфейсов или иные причины,
            связанные с услугами третьих сторон и находящиеся за пределами разумного контроля Xiangji, могут привести к
            задержкам, перерывам в оказании услуг или их временной недоступности.
          </strong>
        </p>
        <p>В таких случаях Xiangji примет разумные меры по фактическим обстоятельствам, включая, помимо прочего:</p>
        <ul>
          <li>восстановление соответствующих услуг;</li>
          <li>переключение на иные технические сервисы;</li>
          <li>отложенную обработку задач;</li>
          <li>повторную обработку соответствующих задач;</li>
          <li>повторное предоставление соответствующих преимуществ услуг;</li>
          <li>иные разумные меры по устранению последствий.</li>
        </ul>
      </section>
      <section>
        <h2>8. Загрузка материалов услуг и хранение данных</h2>
        <h3>Загрузка</h3>
        <p>
          В отношении сгенерированных с помощью ИИ результатов, результатов перевода, результатов редактирования и иного
          цифрового контента, поддерживающего загрузку, вы можете загружать или экспортировать их способом,
          предусмотренным на страницах продуктов Xiangji.
        </p>
        <h3>Ответственность пользователя за резервное копирование</h3>
        <p>
          <strong>
            Вы несёте ответственность за своевременное резервное копирование сгенерированных результатов, обработанных
            файлов, данных проектов и иного важного контента, который вам необходимо хранить в течение длительного
            времени.
          </strong>
        </p>
        <p>
          Если иное не предусмотрено законами и нормативными актами или не согласовано сторонами, Xiangji не гарантирует
          бессрочное хранение данных в случае прекращения услуг, удаления учётной записи или истечения установленного
          платформой срока хранения.
        </p>
        <h3>Данные после прекращения услуг</h3>
        <p>
          В случае аннулирования вашей учётной записи, прекращения услуг или истечения установленного платформой срока
          хранения соответствующего проекта соответствующие данные могут быть удалены либо обработаны в соответствии с
          Политикой конфиденциальности Xiangji.
        </p>
      </section>
      <section>
        <h2>9. Определение момента завершения доставки</h2>
        <p>
          По общему правилу соответствующие цифровые услуги считаются доставленными с момента наступления любого из
          следующих обстоятельств:
        </p>
        <ol>
          <li>преимущества подписки успешно привязаны к вашей учётной записи Xiangji;</li>
          <li>баллы, Credits или иные цифровые преимущества успешно зачислены;</li>
          <li>доступ к API успешно активирован;</li>
          <li>
            задача генерации или обработки с помощью ИИ завершена, и её результат доступен для надлежащего просмотра или
            загрузки;
          </li>
          <li>
            соответствующие услуги предоставлены вашей учётной записи в соответствии с условиями, указанными на
            страницах продуктов;
          </li>
          <li>выполнены иные согласованные сторонами условия доставки.</li>
        </ol>
        <p>
          <strong>
            В отношении цифровых услуг, которые были доставлены или фактически использованы, возвраты и связанные с ними
            процедуры регулируются Политикой возврата Xiangji, Соглашением о покупке подписки Xiangji и иными
            применимыми правилами.
          </strong>
        </p>
      </section>
      <section>
        <h2>10. Изменения настоящей Политики</h2>
        <p>
          <strong>
            Xiangji оставляет за собой право изменять или дополнять настоящую Политику доставки с учётом изменений
            законодательства, развития бизнеса, корректировок продуктов и технических обновлений.
          </strong>
        </p>
        <p>
          В случае существенных изменений настоящей Политики Xiangji уведомит вас посредством объявлений на веб-сайте,
          страниц продуктов, всплывающих окон, уведомлений в приложении или иными разумными способами.
        </p>
        <p>Изменённая Политика вступает в силу с даты публикации или с указанной даты вступления в силу.</p>
      </section>
      <section>
        <h2>11. Свяжитесь с нами</h2>
        <p>
          Если у вас есть вопросы о доставке услуг, статусе заказа, активации услуг или иных связанных с этим вопросах,
          вы можете связаться с нами следующими способами:
        </p>
        <ul>
          <li>
            <strong>Официальный веб-сайт: </strong>
            <a href="https://www.xiangjifanyi.com/" rel="noreferrer" target="_blank">
              https://www.xiangjifanyi.com/
            </a>
          </li>
          <li>
            <strong>Онлайн-служба поддержки: </strong>онлайн-служба поддержки в продукте Xiangji
          </li>
          <li>
            <strong>Электронная почта службы поддержки: </strong>
            <a href="mailto:bussiness@tosoiot.com">bussiness@tosoiot.com</a>
          </li>
          <li>
            <strong>Телефон: </strong>+86 176 6407 5341
          </li>
        </ul>
        <p>Мы рассмотрим ваши обращения в разумный срок после их получения.</p>
        <p>
          <strong>
            По вопросам, не урегулированным настоящей Политикой, преимущественную силу имеют Условия использования
            Xiangji, Политика конфиденциальности Xiangji, Соглашение о покупке подписки Xiangji и иные применимые
            правила оказания услуг.
          </strong>
        </p>
      </section>
    </>
  );
};

export default RuContent;
